import {useCallback, useMemo, useState} from 'react';
import {useSession} from './useSession';
import {useReactQueryAuthenticate} from '../api';

export const useAuthenticate = () => {
	const session = useSession();
	// TODO: proper way to check authenticated here
	const [authenticated, setAuthenticated] = useState(false);
	const [loginMessage, setLoginMessage] = useState('');
	const [sessionExpired, setSessionExpired] = useState(
		session.sessionExpired(),
	);

	// the saml services we will expose as options to the user
	const samlServices = useMemo(
		() => session.samlServices.filter((service) => service.type === 'saml'),
		[session.samlServices],
	);

	const authenticateMutation = useReactQueryAuthenticate({
		onError() {
			// dispatcher.trigger('auth:user:login:invalid');
		},
		onSuccess(sessionKey) {
			setAuthenticated(true);
			session.setCookie('sessionKey', sessionKey, 1);
			session.setKey(sessionKey);
			// dispatcher.trigger('auth:user:login:success');
			window.location.reload();
		},
	});

	const authenticateUser = useCallback(
		async (params: Parameters<typeof authenticateMutation.mutateAsync>[0]) => {
			setSessionExpired(false);
			setLoginMessage('');
			return authenticateMutation.mutateAsync(params);
		},
		[],
	);

	return {
		authenticated,
		authenticating: authenticateMutation.isLoading,
		error: authenticateMutation.error,
		loginMessage: loginMessage || session.data.loginMsg,
		samlServices,
		sessionExpired,
		authenticatedAsOtherUser: session.data.loggedInAsOtherUser as boolean,

		authenticateUser,
	};
};

export default useAuthenticate;
